/**
 * Orders tab
 */
export const orders = {

    storedStatus: {

        'notParsed': 'New',
        'parsed': 'Processed',
        'Client Reviewed': 'Client Reviewed',
        'Allocated': 'Allocated',
        'Accepted': 'Accepted',
        'Scheduling': 'Scheduling',
        'Scheduled': 'Scheduled',
        'In Progress': 'In Progress',
        'Completed': 'Completed',
        'Declined': 'Declined',
    },
    dislayStatus: {
        'notParsed': 'New',
        'parsed': 'Processed',
        'Client Reviewed': 'Client Reviewed',
        'Allocated': 'Allocated',
        'Accepted': 'Accepted',
        'Scheduling': 'Scheduling in Process',
        'Scheduled': 'Customer is Scheduled',
        'In Progress': 'Work in Progress',
        'Completed': 'Job Completed',
        'Declined': 'Declined',
    },
    /** Schedule booking */
    status: {
        Available: 'Available',
        Allocated: 'Allocated',
        Accepted: 'Accepted',
        'Scheduling': 'Scheduling',
        'Scheduled': 'Scheduled',
        'In Progress': 'In Progress',
        'Completed': 'Completed',
        'Declined': 'Declined'

    }
}


/**
-----schedulerequest-----
    Client Reviewed
    Allocated
    Accepted
    Completed

-----schedulebooking-----
    Available
    Allocated
    Accepted
*/


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/orders.ts